import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col truncate" }
const _hoisted_2 = { class: "font-bold" }
const _hoisted_3 = { class: "text-slate-200" }

import VueScheduler from "@/components/misc/VueScheduler.vue";
import {TimelineOptions, TimelineRow} from "@/types/VueScheduler";
import {Task, convertAuftragToTimelineFormat, Group, Groups} from "@/types/Order";
import {ref} from "vue";
import UniversalScheduler from "@/components/misc/UniversalScheduler.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TimeLine',
  props: {
    "modelValue": {},
    "modelModifiers": {},
    "aufgabe": {},
    "aufgabeModifiers": {},
  },
  emits: ["update:modelValue", "update:aufgabe"],
  setup(__props) {

const auftrag = _useModel(__props, "modelValue")
const aufgabe = _useModel<Task>(__props, 'aufgabe')

//console.log("aufgabe", aufgabe.value)

/**
 * Timeline data
 * [
 *   {
 *     row: 0,
 *     background: "bg_color_pro-rot",
 *     text: "text-white",
 *     start: "17/02/2024 01:00",
 *     end: "17/02/2024 02:00",
 *     meta: {title: "Event 1", description: "Event 1 description"},
 *   },
 *   {
 *     row: 1,
 *     background: "bg_color_pro-dunkelblau",
 *     text: "text-white",
 *     start: "17/02/2024 01:00",
 *     end: "17/02/2024 02:15",
 *     meta: {title: "Event 2", description: "Event 2 description"},
 *   },
 *   {
 *     row: 2,
 *     background: "bg_color_pro-dunkelgrau",
 *     text: "text-white",
 *     start: "17/02/2024 02:00",
 *     end: "17/02/2024 03:15",
 *     meta: {title: "Event 3", description: "Event 3 description"},
 *   }
 * ]
 */
//console.log("before", auftrag.value);
const timelineData = convertAuftragToTimelineFormat(auftrag.value as any)
//console.log("after", timelineData)


/**
 * Timeline headers
 */
const timelineHeaders = ref([""]);

/**
 * Generate row data
 */
const timelineRows: Group[] = [
  /*  {
      id: 0,
      name: "Produktion",
      color: "pro_rot",
      height: 0,
      marginTop: 0,
    },
    {
      id: 1,
      name: "TDE",
      color: "pro_hellblau",
      height: 0,
      marginTop: 0,
    },
    {
      id: 2,
      name: "TDM",
      color: "pro_hellgrau",
      height: 0,
      marginTop: 0,
    },*/
  Groups.produktion, Groups.tde, Groups.tdm
];

/**
 * Timeline options
 */
const timelineOptions = ref<TimelineOptions>({
  cellWidth: 85,
  row: {
    height: 50,
    marginTop: 0,
  },
  scale: 0.5,
  start: timelineData.min,
  end: timelineData.max,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    false
      ? (_openBlock(), _createBlock(VueScheduler, {
          key: 0,
          data: _unref(timelineData).data,
          headers: timelineHeaders.value,
          interactive: false,
          items: timelineRows,
          options: timelineOptions.value
        }, {
          event: _withCtx(({ event, properties }) => [
            _createElementVNode("div", {
              class: _normalizeClass([
          event.color,
          event.text,
          'p-2',
          'rounded-lg',
          'shadow-md',
          'text-xs',
          'text-left',
          'text-xs',
          'rounded-md',
          'text-nowrap',
          'overflow-auto',
          'opacity-80',
          'truncate',
        ]),
              style: _normalizeStyle({ width: properties.width + 'px' })
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(event.meta?.title), 1),
                _createElementVNode("div", _hoisted_3, _toDisplayString(event.meta?.description), 1)
              ])
            ], 6)
          ]),
          _: 1
        }, 8, ["data", "headers", "options"]))
      : _createCommentVNode("", true),
    _createVNode(UniversalScheduler, {
      "schedule-data": _unref(timelineData),
      rows: timelineRows,
      focused: aufgabe.value
    }, null, 8, ["schedule-data", "focused"])
  ], 64))
}
}

})